import * as React from "react";

import { useTranslation } from "../../i18n/custom.i18n";
//import i18next from "../../i18n/i18n.config";

//import "bootstrap/dist/css/bootstrap.min.css";
import "./details.css";
import { LazyLoadImageCDN } from "../Card/CDNImage";

import { RobotSpecs } from "./robot-specs";
import { ToolSpecs } from "./tool-specs";
import { StationSpecs } from "./station-specs";
//import { PostSpecs } from "./post-specs";
import { Addin } from "./addin";
import { Post } from "./post";
import * as DetailsUtils from "./details-utils";
import { Description } from "./description";

let search_params = window.location.search;
        
//if(!window.Settings.LOCAL_BUILD) search_params = event.data;
//const { t, i18n } = useTranslation();
const item_data = DetailsUtils.extract_parameter(search_params);
if (item_data == null){
    console.error("Item not found!");
}

var temp_iframe_url = "";
if (window.Paths.ROBODK_WEB_EMBED_CDN){
    let file_folder = "";
    if (DetailsUtils.type == "axis"){
        file_folder = "library-robots";
    } else {
        file_folder = "library-" + DetailsUtils.type + "s";
    }    
    console.log("File folder: " + file_folder);
    temp_iframe_url = window.Paths.ROBODK_WEB_EMBED_CDN + "/downloads-library/" + file_folder + "/" + item_data["F"];
} else {
    temp_iframe_url = window.Paths.ROBODK_WEB_EMBED;
    switch(DetailsUtils.type) {
        case "robot":
            temp_iframe_url += "robotlib/lib/" + item_data["F"]; 
            break;
        case "tool":
            temp_iframe_url += "robotlib/tools/" + item_data["F"];
            break;

        case "station":
            temp_iframe_url += "library-stations/lib/" + item_data["F"];
            break;
    }
}
DetailsUtils.setiFrameUrl(temp_iframe_url);


let data_found = Object.keys(item_data).length > 0;
/*
if (Object.keys(item_data).length > 0){ // Object.keys(item_data).length > 0
    // Display footer 1 second after data_found
    // TODO: Jason, this should be triggered after the page has been loaded!
    // window.display_footer();
    const { t, i18n } = useTranslation();
    document.title = DetailsUtils.item_title(DetailsUtils.type, item_data, t); // item_data["N"] + " | RoboDK";
    
    let meta = document.getElementsByTagName("meta");
    for(let tag of meta) {
        if(tag.name == "description"){
            tag.content = DetailsUtils.item_description(DetailsUtils.type, item_data, t);
            break;
        }
    }
    // setData(item_data);
    // if(!window.LOCAL_BUILD) window.parent.postMessage( { "description": item_data["desc"][DetailsUtils.language] } );
}
*/

export const Details = () => {
    const { t, i18n } = useTranslation();
    document.title = DetailsUtils.item_title(DetailsUtils.type, item_data, t);
    document.querySelector('meta[name="description"]').setAttribute("content", DetailsUtils.item_description(DetailsUtils.type, item_data, t));

    //let [data, setData] = React.useState({});
    //var data = item_data;
    
    //React.useEffect(() => {
    //});
    const [load_3d_view, set_load_3d_view] = React.useState(false);

    // const download_available = ["robot", "robot-test", "tool", "station", "example", "app", "addin", "post"];
    const download_available = ["robot", "robot-test", "tool", "station", "example", "app", "addin", "axis", "object"];
    const preview_available = ["robot", "robot-test", "tool", "station", "example", "axis", "object"];
    // const similar_available = ["robot", "robot-test", "station", "example", "post"];
    const similar_available = ["robot", "robot-test", "station", "example"];

    const has_layout = ["addin", "post"];

    // onmessage = (event) => {
    //     if(event.origin.includes("robodk.com")) {
    //         console.log("onmessage from details");
    //         console.log(event);
    //         //window.location.search = event.data;
    //     }
    // }
    // TODO: how to run this function after render took place?
    /*if (window.fcnDisplayFooter){
        window.fcnDisplayFooter();
    }*/

    React.useEffect(() => {
        window.display_footer();
    });
    
    return (
        <>
            {!data_found && (
                <div id="main-container" className="container-fluid">
                    <div className="row">
                        <div className="col col-12 col-lg-6 offset-lg-3">
                            <div className="row">
                                Browse the <a href="/library">library to find your robot first.</a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Return new error when spcecified language is not available in data? */}

            {data_found && !has_layout.includes(DetailsUtils.type) && (
                <div id="main-container" className="container-fluid">
                    <div className="row">
                        <div id="item-column" className="col col-12 col-lg-6 offset-lg-3">
                            <div className="row">
                                <h1 id={"item-title"}>{DetailsUtils.type == "station" ? DetailsUtils.station_name(item_data, t) : item_data["N"]}</h1>

                                <div id={"item-img"} className={"col-xs-12 col-sm-6 col-lg-6 " + DetailsUtils.type + "-img"}>
                                    <LazyLoadImageCDN 
                                        cdnPath={DetailsUtils.img_cdn}
                                        localPath={DetailsUtils.img}
                                        alt={item_data["N"]}
                                        libAssetsPath={window.Paths.DETAILS_LIB_ASSETS}
                                        width={"300px"}
                                        height={"auto"}
                                    />
                                </div>

                                <div id="specs-area" className="col-xs-12 col-sm-6 col-lg-6">
                                    <div id="item-desc" className="col-xs-12 col-sm-12 col-lg-12">
                                        <Description data={item_data} language={DetailsUtils.language} type={DetailsUtils.type} />
                                    </div>
                                    <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
                                        {t('details.specs')}
                                    </h2>
                                    <table className="table table-striped" style={{marginBottom:"2rem"}}>
                                        {(DetailsUtils.type == "robot" || DetailsUtils.type == "axis") && <RobotSpecs data={item_data} />}
                                        {(DetailsUtils.type == "tool" || DetailsUtils.type == "object") && <ToolSpecs data={item_data} />}
                                        {DetailsUtils.type == "station" && <StationSpecs data={item_data} />}
                                    </table>
                                </div>
                            </div>

                            <div className="row">
                                {download_available.includes(DetailsUtils.type) && (
                                    <div className={(DetailsUtils.type == "addin") ? "col-xs-12 col-sm-12 col-lg-12" : "col-xs-12 col-sm-12 col-lg-6"}>
                                        <a 
                                            className="btn btn-primary center-block details-btn"
                                            onClick={(e) => DetailsUtils.download_item(item_data)}
                                            role="button"
                                        >
                                            <span className="glyphicon glyphicon-cloud-download"></span>
                                            &nbsp;&nbsp;
                                            {/* <span>Download</span> */}
                                            <span>{t('details-buttons.download')}</span>
                                        </a>
                                    </div>
                                )}

                                {preview_available.includes(DetailsUtils.type) && (
                                    <div className="col-xs-12 col-sm-12 col-lg-6">
                                        <a 
                                            className="btn btn-primary center-block details-btn"
                                            onClick={(e) => { 
                                                DetailsUtils.toggle_3d_preview();
                                                set_load_3d_view(!load_3d_view);
                                            }}
                                            role="button"
                                        >
                                            {/* <span>Toggle 3D View</span> */}
                                            <span>{t('details-buttons.toggle-3d')}</span>
                                        </a>
                                    </div>
                                )}

                                {similar_available.includes(DetailsUtils.type) && (
                                    <>
                                        <div className="col-xs-12 col-sm-12 col-lg-6">
                                            <a 
                                                className="btn btn-primary center-block details-btn"
                                                onClick={(e) => DetailsUtils.list_same_brand_items(item_data["B"])}
                                                role="button"
                                            >
                                                {/* <span>{(DetailsUtils.type == "robot") ? "All robots by " + item_data["B"] : "Browse similar projects"}</span> */}
                                                <span>{(DetailsUtils.type == "robot") ? t("details-buttons.same-brand-robots") + item_data["B"] : t("details-buttons.similar-projects")}</span>
                                            </a>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-lg-6">
                                            <a 
                                                className="btn btn-primary center-block details-btn"
                                                onClick={(e) => DetailsUtils.show_similar_items(item_data)}
                                                role="button"
                                            >
                                                {/* <span>Show similar {(DetailsUtils.type == "robot") ? "robots" : "items"}</span> */}
                                                {DetailsUtils.type == "robot" && (
                                                    <span>{t('details-buttons.similar-robots')}</span>
                                                )}
                                                {DetailsUtils.type == "station" && (
                                                    <span>{t('details-buttons.similar-stations')}</span>
                                                )}
                                                {DetailsUtils.type != "robot" && DetailsUtils.type != "station" && (
                                                    <span>{t('details-buttons.similar-items')}</span>
                                                )}
                                            </a>
                                        </div>
                                    </>
                                )}

                            </div>
                        </div>

                        {preview_available.includes(DetailsUtils.type) && (
                            <div 
                                id="preview-3d-container" 
                                className="col col-12 col-lg-6"
                                style={{ display: (DetailsUtils.preview_3d_enabled) ? "block" : "none" }}   
                            >
                                {load_3d_view && (
                                    <iframe
                                        id="preview-3d"
                                        src={DetailsUtils.iframe_url}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {data_found && DetailsUtils.type == "addin" && (
                <Addin 
                    item_data = {item_data}
                />
            )}

            {data_found && DetailsUtils.type == "post" && (
                <Post 
                    item_data = {item_data}
                />
            )}
        </>
    );
}
